/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_AddedInputs */

const cs_ebr_diff_added = /** @type {(inputs: Ebr_Diff_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`přidáno`)
};

const en_ebr_diff_added = /** @type {(inputs: Ebr_Diff_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`added`)
};

/**
* | output |
* | --- |
* | "added" |
*
* @param {Ebr_Diff_AddedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_added = /** @type {((inputs?: Ebr_Diff_AddedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_AddedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_added(inputs)
	return cs_ebr_diff_added(inputs)
});